import { Route, Routes } from "react-router-dom";
import { AccessRequest } from "./list";
import { EditRequest } from "./edit";

export default function AccessRequestRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AccessRequest />} />
      <Route path="/:id_request/editar" element={<EditRequest />} />
    </Routes>
  );
}
